// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhp_ss","PhotoTitleEditForm__cancelBtn":"iy_b bhp_sw bhp_sv"};